// extracted by mini-css-extract-plugin
export var label = "_f7-2";
export var slideContainer = "_f7-0";
export var slider = "_f7-1";